import React, { memo } from 'react'

import {
  Button, Icon, Close, AIGeneratedGradientFilled, ImageAddPlus, BrushAI,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, number, shape, string } from 'prop-types'

import { iconSize } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

const closeIcon = <Icon svgComponent={Close} size={iconSize} notSpaced />
const applyIcon = <Icon svgComponent={AIGeneratedGradientFilled} size={iconSize} notSpaced />
const modifyIcon = <Icon svgComponent={ImageAddPlus} size={iconSize} notSpaced color="darker"/>
const editIcon = <Icon svgComponent={BrushAI} size={iconSize} notSpaced color="darker" />

// Full-height detail view of the selected reference image: the image is shown
// contained on a neutral surface with a close button, and the actions sit in a
// footer below.
function ExpandedImage({ image, onClose, onApply, onModify, onEdit }) {
  const t = useTranslation()

  return (
    <div className="image-assistant-search-tab__preview">
      <div className="image-assistant-search-tab__preview-media">
        <img className="image-assistant-search-tab__preview-image" src={image.url} alt={image.alt} />
        <Button
          type="secondary"
          variant="only-icon"
          size="tiny"
          icon={closeIcon}
          customClass="image-assistant-search-tab__preview-close"
          onClick={onClose}
          aria-label="Collapse image"
        />
      </div>
      <div className="image-assistant-search-tab__preview-footer">
        <div className="image-assistant-search-tab__preview-actions">
          <Button
            type="secondary"
            size="small"
            variant="with-icon"
            customClass="image-assistant-panel__action image-assistant-panel__action--ai"
            icon={applyIcon}
            onClick={() => onApply(image)}
          >
            <span className="image-assistant-panel__action-label cgt-body-base-semibold">
              {t('imageAssistantPanel.actions.useForThreeDGeneration')}
            </span>
          </Button>
          <Button
            type="secondary"
            size="small"
            variant="with-icon"
            customClass="image-assistant-panel__action"
            icon={modifyIcon}
            onClick={() => onModify(image)}
          >
            {t('imageAssistantPanel.actions.modifyImage')}
          </Button>
          <Button
            type="secondary"
            size="small"
            variant="with-icon"
            customClass="image-assistant-panel__action"
            icon={editIcon}
            onClick={() => onEdit(image)}
          >
            {t('imageAssistantPanel.actions.editImage')}
          </Button>
        </div>
      </div>
    </div>
  )
}

ExpandedImage.propTypes = {
  image: shape({
    id: number.isRequired,
    url: string.isRequired,
    alt: string,
  }).isRequired,
  onClose: func.isRequired,
  onApply: func.isRequired,
  onModify: func.isRequired,
  onEdit: func.isRequired,
}

export default memo(ExpandedImage)
